import { Button } from "@chakra-ui/react";
import { useSDK } from "@metamask/sdk-react";
import { useState } from "react";

const MetaMaskButton = ({
  setAddress,
}: {
  setAddress: (val: string) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const { sdk, connected, connecting, provider, chainId } = useSDK();

  console.log(connected);
  console.log(connecting);

  const connect = async () => {
    try {
      setLoading(true);
      const accounts = await sdk?.connect();
      if (accounts) {
        const address = (accounts as string[])[0] as string;
        setAddress(address);
      }
    } catch (err) {
      console.warn(`failed to connect..`, err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button mt="18px" isLoading={loading} onClick={connect} w="100%">
      Log In w/ MetaMask
    </Button>
  );
};

export default MetaMaskButton;
